/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-11 14:06:09
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-21 17:53:56
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/tools/common.ts
 */
import {
  //EnumProductType,
  EnumStatus,
} from 'src/types/common/product';
import { EnumUnitStandard } from 'src/types/common/common';
import { reduxDefaultStatusControl as defaultStatus } from 'src/tools/helper';
import { store } from 'src/store';

const weightUnits = [
  { group: EnumUnitStandard.Imperial, values: [] },
  { group: EnumUnitStandard.Metric, values: [] },
];

const dimensionUnits = [
  { group: EnumUnitStandard.Imperial, values: [] },
  { group: EnumUnitStandard.Metric, values: [] },
];

const subCollapseOpen = (subArr = []) => {
  return subArr.reduce((pre, now) => {
    return { ...pre, [now]: true };
  }, {});
};

const getValidatedData = ({ validation, getState, status }) => {
  store.dispatch(validation(status));
  const _state = store.getState();
  const data = getState()(_state);
  return data;
};

const changeProductStatus = ({
  convertDataFromReduxToServer,
  statusChanges,
  validation,
  getState,
  status,
  form,
}) => {
  const data = getValidatedData({ validation, getState, status });
  const dataValid = data.dataValid;
  if (dataValid && statusChanges) {
    const _data = convertDataFromReduxToServer(data);
    store.dispatch(statusChanges(_data));
  }
};

const common = {
  storeUuid: '1',
  uuid: null,
  status: EnumStatus.Draft,
  timeoutRef: [],
  brands: [],
  fileList: [],
  currencies: [],
  inventoryUuid: null,
  priceTiers: [],
  allSalesChannels: [],
};

const generateSalesChannelAvailableQuantity = (salesChannelQuotas) => {
  return salesChannelQuotas.map((i) => {
    const { name, salesChannelUuid, channelType, availableQuantity } = i;
    return {
      name,
      type: channelType,
      quantity: availableQuantity || 0,
      uuid: salesChannelUuid,
    };
  });
};

const convertSalesChannelAvailableQuantityToSalesChannelQuotas = (
  salesChannelQuotas = [],
) => {
  return salesChannelQuotas.map((i) => {
    const { uuid, name, type, quantity } = i;
    return {
      name,
      channelType: type,
      availableQuantity: quantity,
      salesChannelUuid: uuid,
    };
  });
};

export {
  getValidatedData,
  defaultStatus,
  common,
  subCollapseOpen,
  dimensionUnits,
  weightUnits,
  changeProductStatus,
  generateSalesChannelAvailableQuantity,
  convertSalesChannelAvailableQuantityToSalesChannelQuotas,
};
